import { render } from "./doctor-setting.vue?vue&type=template&id=82b4b9d2"
import script from "./doctor-setting.vue?vue&type=script&lang=js"
export * from "./doctor-setting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__